export const parityTrendQueryKeys = {
  all: ['parity-trend'] as const,
  series: () => [...parityTrendQueryKeys.all, 'series'] as const,
  seriesDetail: (offerBk: string, dateFrom: string, dateTo: string) =>
    [...parityTrendQueryKeys.series(), offerBk, dateFrom, dateTo] as const,
  summaries: () => [...parityTrendQueryKeys.all, 'summary'] as const,
  summary: (offerBk: string, dateFrom: string, dateTo: string) =>
    [...parityTrendQueryKeys.summaries(), offerBk, dateFrom, dateTo] as const,
};
